import { RefObject } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import type { Plan } from '@alltrails/types/Plan';
import PlanTypeCard from '../PlanTypeCard/PlanTypeCard';
import styles from './GiftPlan.module.scss';

type Props = {
  plan: Plan;
  buyGiftButtonRef: RefObject<HTMLAnchorElement | null>;
};

function GiftPlan({ plan, buyGiftButtonRef }: Props) {
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.section}>
          <div className={(styles.row, styles.group)}>
            <div className={styles.row}>
              <PlanTypeCard billedAtOnce plan={plan} isActive extraClasses={styles.card} />
            </div>
          </div>
          <div className={styles.row}>
            <Button
              ref={buyGiftButtonRef}
              linkInfo={{ href: '/gift/customize' }}
              text={<FormattedMessage defaultMessage="Buy gift" />}
              variant="primary"
            />
          </div>
        </div>
        <div className={styles.cancel}>
          <FormattedMessage defaultMessage="Cancel within 30 days and receive a full-refund." />
        </div>
      </div>
    </div>
  );
}

export default GiftPlan;
